import CardData from './CardData';
import type FeatureData from './FeatureData';
import styles from "../components/CardInfo.module.scss";
import i18n from "../i18n";
import { Typography } from '@material-ui/core';
import PhonelinkEraseIcon from "@material-ui/icons/PhonelinkErase";

/**
 * Minimal card shown when a map feature is clicked while offline.
 *
 * It only carries the title taken from the clicked feature, plus an
 * `offline` flag so CardInfo renders a "no network" message instead of
 * the (unavailable) detail content.
 */
class OfflineCard extends CardData {
    offline = true;

    /**
     * Original clicked feature, kept to reproduce the click (and load the real
     * card) once the connection is restored.
     */
    featureData?: FeatureData;

    /**
     * Build an offline card from the clicked feature data.
     */
    static fromFeatureData(placeData: FeatureData): OfflineCard {
        const card = new OfflineCard(placeData.type, { name: placeData.name, url: '' });
        card.featureData = placeData;
        card.clickPoint = placeData.clickPoint;
        // Keep location as a relocate fallback when there is no clickPoint.
        if (placeData.location) {
            card.geo_location = { lon: placeData.location.lng, lat: placeData.location.lat };
        }
        return card;
    }

    /**
     * Card body shown while offline: icon + "no network" message.
     */
    static getCardDOM() {
        return (
            <div className={styles.offlineMessage}>
                <PhonelinkEraseIcon className={styles.offlineIcon} />
                <Typography className={styles.offlineText} variant="h4" component="div">
                    {i18n.t('offline.cardMessage')}
                </Typography>
            </div>
        );
    }

    /**
     * Offline cards have no image, always render small.
     */
    getDetailCardSize(): string {
        return CardData.SMALL;
    }
}

export default OfflineCard;
